import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getPrivateDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "PrivateDocument", ...action.payload }),
		);
		yield put({
			type: types.GET_PRIVATEDOCUMENT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_PRIVATEDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* getPrivateDocumentWatcherSaga() {
	yield takeLatest(types.GET_PRIVATEDOCUMENT_START, getPrivateDocumentHandlerSaga);
}

//create

//delete

function* deletePrivateDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("PrivateDocument", action.payload),
		);
		yield put({
			type: types.DELETE_PRIVATEDOCUMENT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_PRIVATEDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* deletePrivateDocumentWatcherSaga() {
	yield takeLatest(
		types.DELETE_PRIVATEDOCUMENT_START,
		deletePrivateDocumentHandlerSaga,
	);
}

//update
